import React from 'react';
import styled from '@emotion/styled';
import { ArrowIcon, PrintIcon } from '../../../components/icons';
import Button from '../../../components/Button';
import { FiDownload } from 'react-icons/fi';
import { PlusIcon } from '../../OrderEntry/ui/icons';
import { Result } from '../types';
import { useHistory } from 'react-router-dom';

const OrderButton = styled.button`
background-color: #1E8EDF;
padding: 11px 16px;
border-radius: 6px;
color:#fff;
border:none;
cursor: pointer;
`;
interface Props {
  property: Result;
}
const TopBarActions = (props: Props) => {
  const history = useHistory();
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ fontWeight: 'bold', fontSize: 32, textTransform:'capitalize' }}>{props.property?.address}</div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          onClick={(e: MouseEvent) => {
            e.stopPropagation();
            window.print();
          }}
          buttonType="ButtonSecondaryMedium"
          buttonText="Print"
          icon={<PrintIcon stroke="#444340" />}
          width={'87px'}
        />
        {/* <Button
          onClick={(e: MouseEvent) => {
            e.stopPropagation();
          }}
          buttonType="ButtonSecondaryMedium"
          buttonText="Download as PDF"
          icon={<FiDownload />}
          width={'168px'}
        /> */}
        <div style={{marginLeft:16}}>
        <OrderButton onClick={(e) => {
           history.push(`/new-order/${props.property.rpadId}/${props.property?.muniTypes[0]?.stateCode}`);
          e.stopPropagation();
          }}>Convert to Order</OrderButton>
        </div>
      </div>
    </div>
  );
};

export default TopBarActions;
